import React, { useState } from 'react';
import { Form, Input, Button, Card } from 'antd';
import { notification } from '../../AntdGlobal';
import { changePassword } from '../../auth/api';

const ChangePasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    if (values.new_password !== values.confirm_password) {
      notification.error({
        message: 'Error',
        description: "New passwords do not match",
        duration: 5,
      });
      return;
    }

    setLoading(true);
    const res = await changePassword({
      old_password: values.old_password,
      new_password: values.new_password,
    });
    setLoading(false);

    if (res.ok) {
      notification.success({
        message: 'Success',
        description: "Password updated successfully",
        duration: 5,
      });
      form.resetFields();
    }
  };

  return (
    <Card title="Change Password" style={{ maxWidth: 600, margin: '0 auto' }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="old_password"
          label="Old Password"
          rules={[{ required: true, message: 'Please input your old password!' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="new_password"
          label="New Password"
          rules={[{ required: true, message: 'Please input your new password!' }, { min: 8, message: 'Password must be at least 8 characters' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="confirm_password"
          label="Confirm New Password"
          rules={[{ required: true, message: 'Please confirm your new password!' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ChangePasswordPage;
